import React from 'react';
import { Col } from 'components';
import { COLOR } from 'const';
import { modal } from 'components';
import { ChatMessagesContent } from './ChatMessagesContent';

interface ChatMessagesModalProps {
  issueId: string;
  issue?: any;
  onStatusUpdate?: () => void;
}

const ChatMessagesModal = ({ issueId, issue, onStatusUpdate }: ChatMessagesModalProps) => {
  return (
    <Col round1 bgWhite shadow style={{ maxWidth: 1400, width: '95vw', maxHeight: '90vh', overflow: 'hidden' }}>
      <ChatMessagesContent
        issueId={issueId}
        issue={issue}
        onStatusUpdate={onStatusUpdate}
        onClose={() => modal.hide()}
        showCloseButton={true}
      />
    </Col>
  );
};

export default ChatMessagesModal;

